import { apiFetch } from "./client";

export interface TenantUser {
  id: string;
  companyId: string;
  externalId: string | null;
  email: string;
  displayName: string | null;
  role: string;
  authProvider: string;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTenantUserInput {
  email: string;
  displayName?: string;
  role?: string;
  authProvider: string;
}

export interface UpdateTenantUserInput {
  email?: string;
  displayName?: string;
  role?: string;
  authProvider?: string;
}

export interface UserAgentAccessAgent {
  agentId: string;
  name: string;
  isSubagent: boolean;
  /** Direct grant id — present means there's an agent_access row keyed
      to this user that the UI can revoke. */
  directAccessId: string | null;
  viaGroups: Array<{ groupId: string; groupName: string }>;
  hasAccess: boolean;
}

export interface UserAgentAccessResponse {
  userId: string;
  userRole: string;
  agents: UserAgentAccessAgent[];
}

export const tenantUsersApi = {
  list: (companyId: string) =>
    apiFetch<TenantUser[]>(`/companies/${companyId}/users`),

  create: (companyId: string, data: CreateTenantUserInput) =>
    apiFetch<TenantUser>(`/companies/${companyId}/users`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (companyId: string, userId: string, data: UpdateTenantUserInput) =>
    apiFetch<TenantUser>(`/companies/${companyId}/users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),

  delete: (companyId: string, userId: string) =>
    apiFetch<void>(`/companies/${companyId}/users/${userId}`, {
      method: "DELETE",
    }),

  /** Per-user view of agent access — all agents in the tenant, with the
      user's direct + group-mediated grants. Tenant-admin only. */
  agentAccess: (companyId: string, userId: string) =>
    apiFetch<UserAgentAccessResponse>(
      `/companies/${companyId}/users/${userId}/agent-access`,
    ),
};
